import { render } from "./inverseTable.vue?vue&type=template&id=2997062e"
import script from "./inverseTable.vue?vue&type=script&lang=js"
export * from "./inverseTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__